import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {memo} from "react";

import {SquarePlusIcon} from "../../react/components/Icons/SquarePlusIcon";
import {Pressable} from "../ui/pressable";
import {Text} from "../ui/text";
import {VStack} from "../ui/vstack";

type Props = {
    size?: "sm" | "md" | "lg";
    isDragging?: boolean;
    className?: string;
    onOpen: () => void;
};

const containerStyle = tva({
    base: "flex justify-center items-center border border-dashed",
    variants: {
        isDragging: {
            true: "border-primary-600",
            false: "border-blueGray-300"
        },
        size: {
            sm: "w-12 aspect-square p-1.5 rounded-md",
            md: "w-full md:w-[165px] aspect-[3/2] p-2 rounded-lg",
            lg: "w-full md:w-[270px] aspect-[3/2] p-3 rounded-sm"
        }
    }
});

const UploadPlaceholder: React.FC<Props> = ({size = "md", isDragging, className, onOpen}) => {
    return (
        <Pressable className={containerStyle({isDragging, size, className})} onPress={onOpen}>
            <VStack className="items-center" space="sm">
                <SquarePlusIcon size="lg" stroke="blueGray.600" />
                <Text color="blueGray.800" textAlign="center" variant="sm">
                    Drag your file(s) or{" "}
                    <Text color="blue.600" variant="sm">
                        Browse
                    </Text>
                </Text>
            </VStack>
        </Pressable>
    );
};

export default memo(UploadPlaceholder);
